// System
import { Button, Typography } from '@mui/material';

// Components
import { AtLocator } from '@Components/shared/locators/AtLocator';
import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';
import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';

// Types
import { useFreebetsTable } from '@Modal/hooks/freebets/useFreebetsTable';

export const RevokeFreebetModalDialog = () => {
  const { showRevokeFreebetModal, handleRevokeFreebetModal, selectedFreebet, handleRevokeFreebet } =
    useFreebetsTable();

  return (
    <ClosableModal
      name="SetupAviatorRoleDeleteModalDialog"
      title={`Revoke freebet ${selectedFreebet?._id}`}
      open={showRevokeFreebetModal}
      onClose={() => handleRevokeFreebetModal(false)}
      sx={{ width: '592px' }}
    >
      <CreateDialogLayout>
        <Typography variant="body1"> Are you sure you want to revoke this freebet?</Typography>
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => handleRevokeFreebetModal(false)}
            >
              Cancel
            </Button>
          </AtLocator>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleRevokeFreebet(selectedFreebet)}
          >
            Revoke
          </Button>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </ClosableModal>
  );
};
